import React from 'react';
import { setEditId, ImageInterface } from "src/store/community/imagesSlice";
import { formattedDate } from "src/helpers/DateHelpers";
import CardImage from "src/componets/CardImage";
import { ButtonDestroy, ButtonEdit } from "src/componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { destroyImage } from "src/actions/community/imagesActions";
import { message } from "antd";
import { useAppDispatch } from "src/store/hooks";

const Card = ({ image }: { image: ImageInterface }) => {
  const dispatch            = useAppDispatch();
  const formattedCreatedAt  = formattedDate(image.created_at);
  const options             = [
    <ButtonEdit key={`edit-${image.id}`} onClick={() => onClickEdit(image.id)} />,
    <ButtonDestroy key={`destroy-${image.id}`} onClick={() => onClickDestroy(image.id)} />
  ];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyImage(id));

    if (destroyImage.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyImage.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <CardImage
      key={image.id}
      image={image.file_url}
      preview={true}
      options={options}
    >
      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
